import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

function useWarehouseDebtOut(warehouseId, warehouseDebtId) {
  return useSWR(
    warehouseId && warehouseDebtId
      ? {
          path: `/api/v1/warehouses/${warehouseId}/debt-out`,
          method: "GET",
          params: { warehouseDebt: warehouseDebtId },
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseDebtOut;
